<template>
  <table class="table table-hover">
    <thead>
      <tr>
        <th
          v-for="(col, idx) in columns"
          v-bind:key="idx"
          v-on:mouseup="sortColumn(col.idx)"
          v-bind:class="{
            'text-center': col.center,
            'c-hand': col.idx !== undefined
          }"
          v-bind:aria-sort="ariaSort(col.idx)"
        >
          {{ col.name }}<sub v-if="col.sub">{{ col.sub }}</sub>
          <span v-if="sortArrow(col.idx)">&nbsp;{{ sortArrow(col.idx) }}</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(t, idx) in genCosts"
        v-bind:key="idx"
        v-on:mouseup="navigateToGenCost(t.idx)"
        class="c-hand"
      >
        <td>{{ t.gen[GEN_BUS] }}</td>
        <td>{{ costModel(t.genCost) }}</td>
        <td class="text-right">
          <span v-if="t.genCost[STARTUP]">
            &dollar;{{ t.genCost[STARTUP] }}
          </span>
        </td>
        <td class="text-right">
          <span v-if="t.genCost[SHUTDOWN]">
            &dollar;{{ t.genCost[SHUTDOWN] }}
          </span>
        </td>
        <td>
          <span v-html="cost(t.genCost)"></span>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import MPCStore from "../../stores/MPCStore";

import {
  GEN_BUS,
  MODEL,
  STARTUP,
  SHUTDOWN,
  NCOST,
  COST,
  PW_LINEAR,
  POLYNOMIAL
} from "../../stores/idx";

export default {
  name: "GenTable",
  data() {
    return {
      columns: [
        { name: "Bus" },
        { idx: MODEL, name: "Model" },
        { idx: STARTUP, name: "Startup", center: true },
        { idx: SHUTDOWN, name: "Shutdown", center: true },
        { name: "Cost" }
      ],
      sorted: -1,
      ascending: false,
      GEN_BUS: GEN_BUS,
      MODEL: MODEL,
      STARTUP: STARTUP,
      SHUTDOWN: SHUTDOWN
    };
  },
  computed: {
    genCosts() {
      let idx = this.sorted;
      let up = this.ascending;
      return MPCStore.methods
        .getGenCosts()
        .map((genCost, idx) => ({
          genCost,
          gen: MPCStore.methods.getGen(idx),
          idx
        }))
        .sort(function(a, b) {
          if (idx >= 0) {
            return up
              ? b.genCost[idx] - a.genCost[idx]
              : a.genCost[idx] - b.genCost[idx];
          }
          return 0;
        });
    }
  },
  methods: {
    navigateToGenCost(idx) {
      this.$router.push({ name: "genCost", params: { ord: idx + 1 } });
    },
    sortColumn(idx) {
      if (idx >= 0) {
        if (this.sorted === idx) {
          this.ascending = !this.ascending;
        } else {
          this.sorted = idx;
          this.ascending = false;
        }
      }
    },
    ariaSort(idx) {
      if (this.sorted === idx) {
        return this.ascending ? "ascending" : "descending";
      }
      return "none";
    },
    sortArrow(idx) {
      if (this.sorted === idx) {
        return this.ascending ? "▴" : "▾";
      }
    },
    costModel(genCost) {
      if (genCost[MODEL] === PW_LINEAR) {
        return "Piecewise Linear";
      } else if (genCost[MODEL] === POLYNOMIAL) {
        return "Polynomial";
      }
    },
    cost(genCost) {
      if (!genCost) {
        return "";
      } else if (genCost[MODEL] === PW_LINEAR) {
        return "";
      } else if (genCost[MODEL] === POLYNOMIAL) {
        let s = "";
        for (let i = 0; i < genCost[NCOST]; i++) {
          let j = COST + genCost[NCOST] - 1 - i;
          let c = genCost[j];
          if (i !== 0) {
            s += c < 0 ? " - " : " + ";
          }
          s += Math.abs(c);
          if (i > 0) s += "P";
          if (i > 1) s += `<sup>${i}</sup>`;
        }
        s = "";
        let i = 0;
        for (let n = genCost[NCOST] - 1; n >= 0; n--) {
          let c = genCost[COST + i];
          if (i !== 0) {
            s += c < 0 ? " - " : " + ";
          }
          s += Math.abs(c);
          if (n > 0) s += "P";
          if (n > 1) s += `<sup>${n}</sup>`;
          i++;
        }
        return s;
      }
    }
  }
};
</script>
